import React from 'react';
import { Box, Typography, Divider, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import buildInfo from '../config/build-info.json';

interface FooterProps {
  variant?: 'customer' | 'admin' | 'backoffice';
}

// Mowilex corporate site hosts the canonical privacy policy for both
// the marketing site and this portal. Kept as an external absolute
// URL so any updates on the corporate side reach portal users
// without a portal deploy.
const PRIVACY_POLICY_URL = 'https://mowilex.com/en/privacy-policy/';

const Footer: React.FC<FooterProps> = ({ variant = 'customer' }) => {
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{ mt: 'auto', py: 2, px: 3, backgroundColor: 'background.paper', borderTop: 1, borderColor: 'divider' }}
    >
      <Divider sx={{ mb: 1 }} />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {t('footer.copyright', { year: new Date().getFullYear() })}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Link
            href={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            variant="body2"
            color="text.secondary"
            underline="hover"
          >
            {t('footer.privacyPolicy')}
          </Link>
          <Typography variant="body2" color="text.secondary">
            {t('footer.buildInfo', { date: buildInfo.buildDate, version: buildInfo.version })}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
